import store from '../store';


export default {
    formatNotificationSubject: function(data) {
        if(data.type=="UPDATE_REQUEST") {
            return `Request for Card Update from ${data.userName}`;
        } 
        else if(data.type=="BUSINESS_CARD_ACCEPTED") {
            return `${data.userName} accepted their Business Card`;
        } 
        else  if(data.type=="BUSINESS_CARD_DETACHED") {
            return `${data.userName} detached their Business Card`;
        }
        else if(data.type=="MULTICONNECT_ATTENDEE_JOINED"){
            let multiConnectEvents = store.getters.multiConnectEvents;
           
            let event = multiConnectEvents.find(event => event.id == data.multiConnectEventId);
            if(event) return `${data.userName} has joined ${event.name}`;
            else return "";
        }
        else {
            return "";
        }
    },
}